
import { mapGetters } from 'vuex'
export default {
    props: {
        width: { type: String, default: '' },
        height: { type: String, default: '' },
        isCollect: { type: Boolean, default: false }, // 是否已收藏
        isRound: { type: Boolean, default: false } // 是否圆形按钮
    },
    components: { },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters('user', ['token'])
    },
    created() {
    },
    methods: {
        Collect() {
            if(!this.token) return this.$store.commit('setIsLogin', true);
            this.$emit('Collect')
        }
    }
};
